<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="heaven-before-war-broke-out">
<br/><br/><br/><br/><br/><h1>Heaven Before War Broke Out</h1>
<p><strong><br/>
</strong></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch006.vue?14309d59